import SubStepIndicator from './SubStepIndicator';
import './SubStepIndicator.scss';

export default SubStepIndicator;
